import HSFileAttach from '../shared/front_dashboard/hs-file-attach.min'

document.addEventListener('DOMContentLoaded', function () {
  // INITIALIZATION OF FILE ATTACH
  // =======================================================
  new HSFileAttach('.js-file-attach')
})
